/* Galaxy product options for the 5 decoration products (replaces Hulk Product Options).
   Fields, values and property names come from window.GAAU_OPTION_SETS (= option-sets.json, read from the live Hulk
   options 3 Nov 2026). The theme's add-to-cart sends every [name^="properties"] field on the page, so this script keeps
   one hidden properties[...] input per FILLED field (empty fields send nothing) outside the product form.
   Before the theme's add-to-cart runs, a capture-phase click check stops the add when a required field is empty, a logo
   is still uploading, or the quantity is under the minimum. It never re-clicks the button (Hulk's re-click caused the
   double add of Sep 2026). Logo files go to the order server's /upload; the line keeps only the returned reference. */
(function () {
  'use strict';
  var box = document.querySelector('[data-gaau-options]');
  if (!box || !window.GAAU_OPTION_SETS) return;
  var handle = box.getAttribute('data-handle');
  var fields = window.GAAU_OPTION_SETS[handle];
  var rules = window.GAAU_RULES || {};
  if (!fields) return;

  var MAX_BYTES = 4 * 1024 * 1024;
  var EXT = ['png', 'jpg', 'jpeg', 'pdf', 'svg', 'ai', 'eps'];
  var values = {}, uploading = false, cartQty = 0;
  var hidden = document.createElement('div');
  hidden.setAttribute('data-gaau-hidden-props', '');
  hidden.hidden = true;
  box.appendChild(hidden);

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function el(tag, attrs, text) {
    var e = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    if (text) e.textContent = text;
    return e;
  }
  function setValue(prop, value) {
    values[prop] = value;
    var input = hidden.querySelector('[data-prop="' + prop + '"]');
    if (!value) { if (input) input.remove(); return; }
    if (!input) {
      input = el('input', {type: 'hidden', name: 'properties[' + prop + ']', 'data-prop': prop});
      hidden.appendChild(input);
    }
    input.value = value;
    markError(prop, false);
    showFee();
  }
  function markError(prop, on) {
    var f = box.querySelector('[data-field="' + prop + '"]');
    if (f) f.classList.toggle('gaau-field--error', !!on);
  }

  // ---------------------------------------------------------------- fields
  fields.forEach(function (f) {
    var wrap = el('div', {'class': 'gaau-field', 'data-field': f.prop});
    var label = el('div', {'class': 'gaau-field__label'}, f.prop + (f.required ? ' *' : ''));
    wrap.appendChild(label);
    if (f.kind === 'buttons') {
      var group = el('div', {'class': 'gaau-buttons', role: 'radiogroup', 'aria-label': f.prop});
      f.values.forEach(function (v) {
        var fee = (f.fees || {})[v];
        var b = el('button', {type: 'button', 'class': 'gaau-button', role: 'radio', 'aria-checked': 'false', 'data-value': v},
                   v + (fee ? ' (+$' + fee + ')' : ''));
        b.addEventListener('click', function () {
          group.querySelectorAll('.gaau-button').forEach(function (x) { x.setAttribute('aria-checked', 'false'); x.classList.remove('is-selected'); });
          b.setAttribute('aria-checked', 'true'); b.classList.add('is-selected');
          setValue(f.prop, v);
        });
        group.appendChild(b);
      });
      wrap.appendChild(group);
    } else if (f.kind === 'dropdown') {
      var sel = el('select', {'class': 'gaau-select', 'aria-label': f.prop});
      sel.appendChild(el('option', {value: ''}, f.placeholder || 'Choose'));
      f.values.forEach(function (v) { sel.appendChild(el('option', {value: v}, v)); });
      sel.addEventListener('change', function () { setValue(f.prop, sel.value); });
      wrap.appendChild(sel);
    } else if (f.kind === 'text') {
      var input = el('input', {type: 'text', 'class': 'gaau-text', 'aria-label': f.prop, maxlength: f.prop === 'Notes' ? '1000' : '3000'});
      input.addEventListener('input', function () { setValue(f.prop, input.value.trim()); });
      wrap.appendChild(input);
    } else if (f.kind === 'file') {
      var file = el('input', {type: 'file', 'class': 'gaau-file', 'aria-label': f.prop, accept: '.' + EXT.join(',.')});
      var status = el('div', {'class': 'gaau-file__status', 'aria-live': 'polite'});
      file.addEventListener('change', function () { upload(file, status, f.prop); });
      wrap.appendChild(file);
      wrap.appendChild(status);
      wrap.appendChild(el('div', {'class': 'gaau-field__hint'},
        'PNG, JPG, PDF, SVG, AI or EPS, up to 4 MB. Bigger file? Email it to sales@galaxyapparel.com.au.'));
    }
    wrap.appendChild(el('div', {'class': 'gaau-field__error'}, f.kind === 'file' ? '' : 'Please ' + (f.kind === 'text' ? 'fill in' : 'choose') + ' ' + f.prop.toLowerCase() + '.'));
    box.insertBefore(wrap, hidden);
  });
  var feeNote = el('div', {'class': 'gaau-fee-note', 'aria-live': 'polite'});
  var message = el('div', {'class': 'gaau-message', role: 'alert'});
  box.insertBefore(feeNote, hidden);
  box.insertBefore(message, hidden);

  function showFee() {
    var setup = values['Logo setup'];
    var cents = setup && window.GaauPricing ? window.GaauPricing.setupFee(rules, handle, setup) : 0;
    feeNote.textContent = cents ? '+ ' + money(cents) + ' one-off setup fee for this logo (added at checkout).' : '';
  }

  // ---------------------------------------------------------------- logo upload
  function upload(input, status, prop) {
    setValue(prop, '');
    var f = input.files && input.files[0];
    if (!f) { status.textContent = ''; return; }
    var ext = (f.name.split('.').pop() || '').toLowerCase();
    if (EXT.indexOf(ext) < 0) { status.textContent = 'Logo files can be PNG, JPG, PDF, SVG, AI or EPS.'; input.value = ''; return; }
    if (f.size > MAX_BYTES) { status.textContent = 'This file is over 4 MB. Please email it to sales@galaxyapparel.com.au.'; input.value = ''; return; }
    uploading = true;
    status.textContent = 'Uploading ' + f.name + '…';
    var reader = new FileReader();
    reader.onload = function () {
      var data = String(reader.result).split(',')[1] || '';
      fetch(window.GAAU_ORDERS_URL + '/upload', {method: 'POST', headers: {'Content-Type': 'application/json'},
                                                 body: JSON.stringify({filename: f.name, data: data})})
        .then(function (r) { return r.json().then(function (j) { return {ok: r.ok, body: j}; }); })
        .then(function (res) {
          if (res.ok && res.body.ref) { setValue(prop, res.body.ref); status.textContent = '✓ ' + f.name + ' uploaded.'; }
          else { status.textContent = (res.body && res.body.message) || 'Upload failed. Please try again.'; input.value = ''; }
        })
        .catch(function () { status.textContent = 'Upload failed. Please try again, or email the file to sales@galaxyapparel.com.au.'; input.value = ''; })
        .finally(function () { uploading = false; });
    };
    reader.onerror = function () { uploading = false; status.textContent = 'The file could not be read.'; };
    reader.readAsDataURL(f);
  }

  // ---------------------------------------------------------------- quantity minimum
  var minimum = (rules.minimums || {})[handle];
  // The page has a visible quantity box outside the form and a hidden one inside it (the theme copies one to the other).
  // Only the product page's boxes (they carry data-product); the side cart's line boxes must never be touched.
  function qtyInputs() { return [].slice.call(document.querySelectorAll('input[name="quantity"][data-product]')); }
  function qtyInput() { return qtyInputs().filter(function (i) { return i.offsetParent !== null; })[0] || qtyInputs()[0]; }
  function setQty(n) {
    qtyInputs().forEach(function (i) { i.value = n; i.dispatchEvent(new Event('change', {bubbles: true})); });
  }
  if (minimum) {
    var q = qtyInput();
    if (q && parseInt(q.value, 10) < minimum.qty) { setQty(minimum.qty); }
    box.insertBefore(el('div', {'class': 'gaau-min-note'}, 'Minimum ' + minimum.qty +
      (minimum.per === 'logo_line' ? ' per logo.' : '.')), feeNote);
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); })
      .then(function (cart) { cartQty = cart.items.filter(function (i) { return i.handle === handle; }).reduce(function (s, i) { return s + i.quantity; }, 0); })
      .catch(function () {});
  }

  // ---------------------------------------------------------------- add-to-cart check (before the theme's handler)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-btn-addtocart]');
    if (!btn || btn.closest('[data-quickshop]')) return;
    var problems = [];
    fields.forEach(function (f) {
      var missing = f.required && !values[f.prop];
      markError(f.prop, missing);
      if (missing) problems.push(f.prop);
    });
    var text = '';
    if (problems.length) text = 'Please choose: ' + problems.join(', ') + '.';
    else if (uploading) text = 'Please wait for the logo upload to finish.';
    else if (minimum) {
      var q = qtyInput(), qty = q ? parseInt(q.value, 10) || 0 : 0;
      var have = minimum.per === 'product' ? qty + cartQty : qty;
      if (have < minimum.qty) {
        if (q) setQty(minimum.qty - (minimum.per === 'product' ? cartQty : 0));
        text = 'The minimum is ' + minimum.qty + (minimum.per === 'logo_line' ? ' per logo' : '') + '. We have set the quantity to ' +
               (q ? q.value : minimum.qty) + '. Need fewer? Ask for a quote.';
      }
    }
    message.textContent = text;
    if (text) { e.preventDefault(); e.stopImmediatePropagation(); message.scrollIntoView({block: 'center', behavior: 'smooth'}); return; }
    var shown = qtyInput();  // the theme adds the form's box: make it equal what the customer sees
    if (shown) qtyInputs().forEach(function (i) { i.value = shown.value; });
    if (minimum && minimum.per === 'product') cartQty += shown ? parseInt(shown.value, 10) || 0 : 0;
  }, true);
})();
